import type { RequestScope } from "./ApiService";

/** A null and an empty ambient identity both mean "acts as itself". */
export const identityOf = (scope: RequestScope): string => scope.ambientEmail || "";

/**
 * Whether two request scopes are the same organisation: the same Function App and the same
 * ambient identity. The access provider keys its answer on this, and the assistant's intent
 * buses keep an intent to the organisation it was asked in by it. Pure, and kept apart from
 * the provider and the API client so that a test mocking either still compares for real.
 */
export const sameRequestScope = (a: RequestScope, b: RequestScope): boolean =>
  a.bffRoot === b.bffRoot && identityOf(a) === identityOf(b);
